export default function SizeSelector({ sizes=[], value, onChange }){
  return (<div className="flex flex-wrap gap-2">
    {sizes.map(s => (
      <button key={s.title} disabled={!s.inStock} onClick={()=>onChange(s.title)} className={`rounded-xl border px-3 py-1 text-sm ${value===s.title?'border-slate-900':'border-slate-200'} ${s.inStock?'':'opacity-40 cursor-not-allowed'}`}>
        {s.title}
      </button>
    ))}
  </div>);
}
